import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as fileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  constructor(
    private translateService: TranslateService
  ) { }
  // 下载模板
  downloadTemplateExcel(excelname: string) {
    const url = `../../../assets/template-excel/${excelname}`;
    fileSaver(url, excelname);
  }
  // 导出为Excel
  async exportToExcel(excelFileName: string, tabelOption: Array<object>, tabelData: Array<any>, table2MergeIndex?: Array<number>) {
    // 导入excelJS
    const ExcelJS = require('exceljs');
    // 创建工作簿
    const workbook = new ExcelJS.Workbook();
    // 添加工作表
    let workSheet = workbook.addWorksheet('Sheet');
    // 向工作表中添加行
    workSheet.addRows(!!table2MergeIndex ? tabelData : this.handleExcelData(tabelOption, tabelData));
    // 标单的表格样式调整
    if (!!table2MergeIndex) {
      // 单元格合并
      this.excelMergeOfBid(tabelData, workSheet, table2MergeIndex);
      // 设置样式
      this.excelStyleOfBid(tabelData, workSheet, table2MergeIndex);
    }
    // 写入并通透过 fileSaver 方法导出
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel';
    await workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: fileType });
      fileSaver(blob, excelFileName + '.xlsx');
    });
  }
  // 除标单外的数据处理
  handleExcelData(tabelOption: Array<object>, tabelData: Array<any>) {
    let [tableColumnsKey, tableColumns, tabelOptionKeys] = [[], [], []];
    // 处理表头
    tabelOption.forEach(element => {
      tableColumnsKey.push(this.translateService.instant(element['text']));
      tableColumns.push({ header: this.translateService.instant(element['text']), key: element['value'] })
      tabelOptionKeys.push(element['value']);
    });
    // 处理除表头外的数据
    const rowsData: any[][] = [...tabelData].map((item) => {
      const newItem = [];
      tabelOptionKeys.forEach((key, index) => {
        newItem.push(item[key]);
      });
      return newItem;
    });
    // 在头部插入表头
    rowsData.unshift(tableColumnsKey);
    return rowsData;
  }
  // 标单:表格样式
  excelStyleOfBid(rowsData: Array<any>, workSheet: any, table2MergeIndex?: Array<number>) {
    const bidWidthArr = [15, 20, 20, 20, 20, 30, 20, 30, 20, 20, 20, 20, 40];
    // 处理视图缩放/显示或隐藏网格线
    workSheet.views = [
      {
        zoomScale: 70,
        showGridLines: false
      }
    ];
    // 处理列宽
    rowsData[13].forEach((element, index) => {
      workSheet.getColumn(index + 1).width = bidWidthArr[index];
    });
    // 处理每一行的字体样式和对齐样式
    rowsData.forEach((element, index) => {
      workSheet.getRow(index + 1).alignment = {
        vertical: "middle",
        horizontal: index > 0 ? 'left' : 'center',
        wrapText: true,
      };
      workSheet.getRow(index + 1).font = {
        name: "Microsoft YaHei",
        family: 2,
        size: index === 0 ? 35 : 14,
        bold: [8, 12, 13].includes(index) || index === rowsData.length - 15 ? true : false
      };
      // 设置边框
      bidWidthArr.forEach((ele, i) => {
        if (index >= 8 && index < rowsData.length - 14) {
          workSheet.getRow(index + 1).getCell(i + 1).border = {
            top: { style: index + 1 === 9 ? 'thick' : 'thin' },
            left: { style: (i + 1 === 1) || ((index + 1 === 13 || table2MergeIndex.includes(index)) && i + 1 <= 8) ? 'thick' : 'thin' },
            bottom: { style: 'thin' },
            right: { style: i + 1 === 13 ? 'thick' : 'thin' }
          };
        }
        else if (index >= rowsData.length - 14 && index <= rowsData.length - 2) {
          workSheet.getRow(index + 1).getCell(i + 1).border = {
            left: { style: i + 1 === 13 ? 'dotted' : 'thick' },
            right: { style: i + 1 === 13 ? 'thick' : 'dotted' },
            bottom: { style: index === rowsData.length - 2 ? 'thick' : null },
          };
        }
      });
    });
    return workSheet;
  }
  // 标单:单元格合并
  excelMergeOfBid(rowsData: Array<any>, workSheet: any, table2MergeIndex: Array<number>) {
    // 处理单元格合并
    workSheet.mergeCells('A1:M1');
    // table前的单元格合并
    for (let i = 2; i <= 8; i++) {
      workSheet.mergeCells(`A${i}:F${i}`);
      if (i === 8) {
        workSheet.mergeCells(`J${i}:K${i}`);
        workSheet.mergeCells(`L${i}:M${i}`);
      }
      else {
        workSheet.mergeCells(`J${i}:M${i}`);
      }
    };
    // table1的单元格合并
    const table1MergeIndex = [9, 10, 11, 12];
    table1MergeIndex.forEach(ele => {
      workSheet.mergeCells(`B${ele}:F${ele}`);
      workSheet.mergeCells(`G${ele}:H${ele}`);
      workSheet.mergeCells(`K${ele}:L${ele}`);
    });
    // table1--合计的单元格合并
    workSheet.mergeCells('A13:H13');
    // table1--含税总价的单元格合并
    workSheet.mergeCells(`K13:L13`);
    // table2中的分类项次的单元格合并
    table2MergeIndex.forEach(ele => {
      workSheet.mergeCells(`A${ele + 1}:H${ele + 1}`);
    })
    // 备注除的单元格合并
    for (let i = rowsData.length - 13; i <= rowsData.length - 1; i++) {
      workSheet.mergeCells(`A${i}:J${i}`);
    }
    // 盖章处的单元格合并
    workSheet.mergeCells(`K${rowsData.length - 13}:M${rowsData.length - 1}`);
    // 最后一行的单元格合并
    workSheet.mergeCells(`A${rowsData.length}:M${rowsData.length}`);
  }

}
